module.exports = __webpack_public_path__ + "static/media/btn_add_patient.32cc8577.svg";